import React, { Component, Fragment } from "react";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import { dataFormatters } from "../../../../utils/dataFormatters";
import ReportInfoSection from "../../../../libraries/ReportGenerator/ReportInfoSection";
import { FixedAppLookupsContext } from "../../../FixedAppLookupsProvider";
import { DetailsTableSchema, CommentTableSchema, ComplianceTableSchema, PreviousOfDutyTableSchema } from "./TablesHeaderSchema";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { MultiDayHosGraphicalView } from "../../Helper/HosGraphicalView";
import moment from "moment";
import { themeService } from "../../../../theme/service/activeTheme.service";
import { Col, Row } from "reactstrap";
import { switchReportStyle } from "../../../Reports/Timps/Switch/style";
import "./style.css";
import { HosGraphicalView } from "../../Helper/HosGraphicalView/index_v2";
import { languageService } from "../../../../Language/language.service";

const SectionHeader = ({ title }) => {
  return <div style={{ padding: "5px", textAlign: "left", fontSize: "24px", fontWeight: 600 }}>{title}</div>;
};

const DetailsOfServiceActivityKey = ({ records = [] }) => {
  let codes = new Set();
  let unique = records
    .filter((record) => record.activityType)
    .filter((record) => {
      const { code } = record.activityType;
      if (codes.has(code)) {
        return false;
      }
      codes.add(code);
      return true;
    });
  return unique.length ? (
    <Fragment>
      <SectionHeader title="Key" />
      <Row>
        <Col md={12}>
          <div className="details-of-service-activiy-key">
            {unique
              .filter((record) => record.activityType)
              .map((record, i) => {
                const { group, value, code } = record.activityType;
                return (
                  <div key={i}>
                    <span style={{ width: "30px", display: "inline-block" }}>{code}</span>
                    <span>{` --  Group: ${group}, Description: ${value} (${code})`}</span>
                  </div>
                );
              })}
          </div>
        </Col>
      </Row>
      <span className="spacer"></span>
    </Fragment>
  ) : null;
};

class DetailsOfServiceReport extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { day, timezone, user, effectiveDate, latestHosRecord, msgObj, displayGraphicalView } = this.props;
    const { offDuty, msg, nonCompliant } = msgObj;
    const { getHosLocationOpt2BasedOnCode } = this.context;
    const { records } = day;
    const newCommentArray = records.filter((obj) => obj.hasOwnProperty("comments"));
    const newViolationData = records.flatMap(({ violations, ...rest }, i) => {
      return violations.map((e) => {
        return { ...rest, violations: e };
      });
    });
    const { HosInfo, name, teamLeadName } = user;
    // for Make the First char Capital
    let capitalName = name.charAt(0).toUpperCase() + name.slice(1);
    const { HQ } = HosInfo;
    const { city, division, state, subdivision, description } = getHosLocationOpt2BasedOnCode(HQ);

    return (
      <div
        className="mainContent table-report records-of-service last-page-break-print"
        style={{ ...themeService(switchReportStyle.mainStyle) }}
      >
        <ReportTitleSection
          title={languageService(`Details of Service`)}
          fontSizeOverride={"36px"}
          centerTitle={true}
          subTitle={`${dataFormatters.dateFormatterWithTimezone(day.date, timezone)}`}
        />

        <ReportInfoSection
          fontSizeOverride={"22px"}
          titleWidthOverride={{
            col1: "160px",
            col2: "230px",
          }}
          rows={[
            {
              col1: {
                title: languageService("Employee"),
                value: capitalName,
              },
              col2: {
                title: languageService("Headquarters"),
                value: description,
              },
            },
            {
              col1: {
                title: languageService("Supervisor"),
                value: teamLeadName ? teamLeadName : "N/A",
              },
              col2: {
                title: languageService("Timezone"),
                value: timezone,
              },
            },
            {
              col1: {
                title: languageService("City/State"),
                value: `${city ? city : "--"}/${state ? state : "--"}`,
              },
              col2: {
                title: languageService("Division/Subdivision"),
                value: `${division ? division : "--"}/${subdivision ? subdivision : "--"}`,
              },
            },
          ]}
        />
        <span className="spacer"></span>
        <DetailsOfServiceActivityKey records={day.records} />

        {this.props.showPriorTimeOff && (
          <React.Fragment>
            <SectionHeader title={languageService("Prior Off Duty")} />
            <table className="table-bordered" style={{ fontSize: "22px", textAlign: "center", minWidth: "1000px", width: "100%" }}>
              {PreviousOfDutyTableSchema.map((e) => (
                <ReportTableSectionRenderer section={e} rowsData={day.previousOffTime || {}} />
              ))}
            </table>
          </React.Fragment>
        )}
        <SectionHeader title={languageService("Time Served")} />
        <table className="table-bordered" style={{ fontSize: "22px", textAlign: "center", minWidth: "1000px", width: "100%" }}>
          <ReportTableSectionRenderer section={DetailsTableSchema} rowsData={day.records} />
        </table>

        <SectionHeader title={languageService("Comments")} />
        <table className="table-bordered" style={{ fontSize: "22px", width: "100%", textAlign: "center", minWidth: "1000px" }}>
          <ReportTableSectionRenderer section={CommentTableSchema} rowsData={newCommentArray} />
        </table>
        <SectionHeader title={languageService("Service Chart")} />
        <div className="service-chart-message">
          {msg} {offDuty} {nonCompliant}
        </div>
        {/* <MultiDayHosGraphicalView
          reportingPeriod={day.records}
          viewStartDate={moment.tz(day.date, timezone)}
          timezone={timezone}
          singleDayViewOnly={displayGraphicalView}
        /> */}
        <HosGraphicalView
          latestHosRecord={latestHosRecord}
          records={day.records}
          viewStartDate={moment.tz(day.date, timezone)}
          timezone={timezone}
          singleDayViewOnly={displayGraphicalView}
        />
        <span className="spacer"></span>
        <SectionHeader title={languageService("Compliance")} />

        <table className="table-bordered" style={{ fontSize: "22px", minWidth: "1000px", textAlign: "center", width: "100%" }}>
          <ReportTableSectionRenderer section={ComplianceTableSchema} rowsData={newViolationData} />
        </table>
      </div>
    );
  }
}

DetailsOfServiceReport.contextType = FixedAppLookupsContext;

export default DetailsOfServiceReport;



// WEBPACK FOOTER //
// ./src/components/HoursOfService/HosReport/DetailsOfServiceReport/index.jsx